<template>
  <div class="page">
    <div class="list">
        <div class="item" v-for="(item,index) in list" :key="index" v-if="item.remark_type!='centrifuge'">
            <button class="btn">{{item.title}}</button>
            <div class="lists">
                <div class="items" v-for="(items,indexs) in item.children" :key="indexs" @click="gotoDetail(items.id)">
                    <img class="img" :src="cdnUrl+items.img_src" alt="">
                    <div class="name">{{items.title}}</div>
                </div>
            </div>
            <div class="tips" v-if="item.children&&item.children.length>3">
                <img class="icon" :src="cdnUrl+'eppendorf/arrow_icon.png'" alt="">
                <div class="tip_txt">左右活动查看更多系列</div>
                <img class="icon right" :src="cdnUrl+'eppendorf/arrow_icon.png'" alt="">
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getProCate } from '@/api/centrifuge'
export default {
  components: {
    
  },
  data() {
    return {
      cdnUrl: this.$config.baseUrl.cdnUrl,
      list:[]
    }
  },
  created() {
    this.getCategoryList()
    
  },
  methods: {
    getCategoryList(){
        getProCate({type:7}).then(res => {
            this.list = res
        })
    },
    gotoDetail(id){
        this.$router.push({ name: 'operateGuide', query: { id:id,centrifugeType:2 } })
    }
  }
}
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF;
    .list{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: rem(13);
        .item{
            width: rem(343);
            margin-bottom: rem(23);
            .btn{
                height: rem(36);
                background: #6CC5DB;
                border-radius: rem(2);
                border: unset;
                padding: 0 rem(12);
                font-size: rem(14);
                color: #FFFFFF;
            }
            .lists{
                width: rem(343);
                // height: rem(147);
                display: flex;
                margin-top: rem(16);
                overflow-x: auto;
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none;
                .items{
                    width: rem(100);
                    // height: rem(147);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: rem(22);
                    .img{
                        width: rem(100);
                        height: rem(117);
                        box-shadow: 0px rem(2) rem(8) 0px rgba(28,106,121,0.16);
                        border-radius: rem(4);
                        border: rem(1) solid rgba(89,193,214,0.3);
                    }
                    .name{
                        // font-weight: bold;
                        font-size: rem(12);
                        color: #000000;
                        line-height: rme(17);
                        margin-top: rem(12);
                        overflow:hidden;
                        text-overflow:ellipsis;
                        display:-webkit-box;
                        -webkit-box-orient:vertical;
                        -webkit-line-clamp:2; 
                    }
                }
            }
            .tips{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: rem(15);
                .icon{
                    width: rem(23);
                    height: rem(12);
                }
                .tip_txt{
                    font-size: rem(12);
                    color: #999999;
                    line-height: rem(17);
                    margin: 0 rem(9);
                }
                .right{
                    transform: rotate(180deg);
                }
            }
        }
    }
    
}
</style>